import Footer from "../components/Footer";

const TermsAndConditions = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12 text-gray-800">
      <h1 className="text-3xl font-bold mb-6">Terms and Conditions</h1>

      <p className="mb-4">
        Welcome to <strong>Bill-lex.com</strong>, a product of{" "}
        <strong>Lexora Technologies OPC Private Limited</strong>. These Terms
        and Conditions govern your use of our billing and inventory management
        platform. By accessing or using our services, you agree to be bound by
        these terms.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">
        1. Acceptance of Terms
      </h2>
      <p className="mb-4">
        By creating an account, accessing, or using Bill-lex.com, you accept and
        agree to be bound by these Terms and Conditions. If you do not agree to
        these terms, please do not use our services. These terms apply to all
        users of the platform, including merchants, businesses, and their
        authorized representatives.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">
        2. Service Description
      </h2>
      <p className="mb-4">
        Bill-lex.com provides a comprehensive billing and inventory management
        solution that includes:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>Digital invoice generation and management</li>
        <li>Inventory tracking and stock management</li>
        <li>Payment processing through Cashfree integration</li>
        <li>Business analytics and reporting</li>
        <li>Customer order management</li>
        <li>GST-compliant billing features</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-3">
        3. User Registration and Account
      </h2>
      <p className="mb-4">
        To use our services, you must register for an account and provide
        accurate, complete, and current information. You are responsible for:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>Maintaining the confidentiality of your account credentials</li>
        <li>All activities that occur under your account</li>
        <li>Notifying us immediately of any unauthorized use</li>
        <li>
          Ensuring your account information remains accurate and up-to-date
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-3">
        4. Acceptable Use Policy
      </h2>
      <p className="mb-4">
        You agree to use Bill-lex.com only for lawful purposes and in accordance
        with these terms. You are strictly prohibited from:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>
          Using the service for any illegal, fraudulent, or unauthorized purpose
        </li>
        <li>
          Violating any applicable laws, regulations, or third-party rights
        </li>
        <li>
          Attempting to gain unauthorized access to our systems or other users'
          accounts
        </li>
        <li>Interfering with or disrupting the service or servers</li>
        <li>Transmitting viruses, malware, or other harmful code</li>
        <li>
          Engaging in any activity that could damage, disable, or impair our
          services
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-3">
        5. Prohibited Business Activities
      </h2>
      <p className="mb-4">
        <strong>
          Bill-lex.com strictly prohibits the use of our platform for the
          following activities:
        </strong>
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>Adult content, pornography, or sexually explicit materials</li>
        <li>Illegal drugs, controlled substances, or drug paraphernalia</li>
        <li>Gambling, lotteries, or unauthorized gaming activities</li>
        <li>Money laundering, fraud, or financial crimes</li>
        <li>Counterfeit goods or intellectual property violations</li>
        <li>Weapons, ammunition, or explosive materials</li>
        <li>Any activity that violates Indian laws or regulations</li>
      </ul>
      <p className="mb-4">
        Violation of these prohibitions will result in immediate account
        termination and may lead to legal action.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">6. Payment Terms</h2>
      <p className="mb-4">
        Our payment processing is handled through Cashfree, and you agree to:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>Comply with Cashfree's terms of service and policies</li>
        <li>Provide accurate payment information</li>
        <li>Pay all applicable fees and charges</li>
        <li>Maintain sufficient funds for transactions</li>
        <li>Not engage in any fraudulent payment activities</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-3">7. Data and Privacy</h2>
      <p className="mb-4">
        Your use of Bill-lex.com is also governed by our Privacy Policy, which
        is incorporated into these terms by reference. You acknowledge that:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>
          We may collect, use, and store your data as described in our Privacy
          Policy
        </li>
        <li>
          You are responsible for the accuracy and legality of data you upload
        </li>
        <li>You must comply with applicable data protection laws</li>
        <li>We may use your data to provide and improve our services</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-3">
        8. Intellectual Property
      </h2>
      <p className="mb-4">
        Bill-lex.com and its content, features, and functionality are owned by
        Lexora Technologies OPC Private Limited and are protected by copyright,
        trademark, and other intellectual property laws. You may not:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>Copy, modify, or distribute our proprietary content</li>
        <li>Reverse engineer or attempt to extract source code</li>
        <li>Use our trademarks or branding without permission</li>
        <li>Create derivative works based on our platform</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-3">
        9. Limitation of Liability
      </h2>
      <p className="mb-4">
        To the maximum extent permitted by law, Lexora Technologies OPC Private
        Limited shall not be liable for any indirect, incidental, special,
        consequential, or punitive damages arising from your use of our
        services. Our total liability shall not exceed the amount you paid for
        our services in the 12 months preceding the claim.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">
        10. Service Availability
      </h2>
      <p className="mb-4">
        We strive to provide reliable service but cannot guarantee uninterrupted
        availability. We may temporarily suspend services for maintenance,
        updates, or technical issues. We are not liable for any losses resulting
        from service interruptions.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">11. Termination</h2>
      <p className="mb-4">
        We may terminate or suspend your account at any time for violation of
        these terms or for any other reason at our sole discretion. Upon
        termination, your right to use our services ceases immediately, and we
        may delete your account and data.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">12. Governing Law</h2>
      <p className="mb-4">
        These terms are governed by the laws of India. Any disputes arising from
        these terms or your use of our services shall be subject to the
        exclusive jurisdiction of courts in India.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">13. Changes to Terms</h2>
      <p className="mb-4">
        We reserve the right to modify these terms at any time. Changes will be
        effective immediately upon posting. Your continued use of our services
        after changes constitutes acceptance of the modified terms.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">
        14. Contact Information
      </h2>
      <p className="mb-4">
        For questions about these Terms and Conditions, please contact us at{" "}
        <a
          href="mailto:billlex.owner@gmail.com"
          className="text-blue-600 underline"
        >
          billlex.owner@gmail.com
        </a>
        .
      </p>

      <p className="mt-8 text-sm text-gray-600">
        <strong>Last updated:</strong> December 2024
      </p>

      <Footer />
    </div>
  );
};

export default TermsAndConditions;
